import { Tag } from "bbcode-to-react";
import * as React from "react";
class FontTag extends Tag {
    toHTML() {
        const font = this.params.font;
        return [`<span style="font-family:${font}">`, this.getContent(), "</span>"];
    }
    toReact() {
        const font = this.params.font;
        return React.createElement("span", { style: { fontFamily: font } }, this.getComponents());
    }
}
export default FontTag;
